<template>
  <section class="video-group">
    <div class="wrap">
      <h2 class="section-title">
        Lokale film
      </h2>

      <div class="videos">
        <div ref="items" class="video" :key="video.io" v-for="video in videos">
          <h3 class="video-title">{{ video.cta }}</h3>
          <media :item="video" />
        </div>
      </div>

      <div class="wrap">
        <router-link :to="{ name: 'Cases'}" class="button button-red filled button-more">
          Se alle cases
          <span><icon-slide-arrow fill="white" /></span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import AbstractSection from './abstract'
import Media from './media'
import iconSlideArrow from '@icons/icon-slide-arrow'

export default AbstractSection.extend({
  components: { Media, iconSlideArrow },
  data: () => ({
    showAll: false
  }),
  computed: {
    videos () {
      return this.showAll ? this.item.videos : this.item.videos.slice(0, 3)
    }
  }
})
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

.video-group {
  background-color: $color-grey-x;
  padding-top: $global-padding * 2;
  padding-bottom: $global-padding * 2;

  position: relative;

  @media #{$above-breakpoint-1024} {
    margin-bottom: $global-padding * 10;

    padding-top: $global-padding * 5;
    padding-bottom: $global-padding * 7;
  }
}

.section-title {
  @include font-size(30px, 40px);
  font-weight: 600;

  margin-bottom: $global-padding;
}

.videos {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.video {
  flex: 0 0 100%;
  max-width: 100%;

  margin-top: $global-padding * 2;

  @media #{$above-breakpoint-768} {
    flex: 0 0 48%;
    max-width: 48%;
  }

  @media #{$above-breakpoint-1024} {
    flex: 0 0 31%;
    max-width: 31%;
  }
}

.video-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: $global-padding / 4;
}

.button-more {
  margin-top: $global-padding * 2;

  @media #{$above-breakpoint-768} {
    position: absolute;
    bottom: 0;
    left: 50%;

    margin-top: 0;

    transform: translateY(50%) translateX(-50%);
  }

  &:hover {
    span {
      transition: transform $duration-normal $easeing-OutExpo;
      transform: translateX(5px);
    }
  }

  span {
    transition: transform $duration-normal $easeing-OutExpo;
    margin-left: calc(#{$global-padding} / 2);

    svg {
      transform: rotate(-90deg) scale(0.7);
    }
  }
}
</style>

<style lang="scss">
@import '~@styles/mq/variables';

  .video-group .media {
    &, .wrap {
      padding: 0;
      margin: 0;
    }

    .icon-play {
      @media #{$above-breakpoint-1024} {
        transform: translate(-50%, -50%) scale(0.75);
      }
    }

    .media-text {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/video-group.vue